import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from './../../reducer';
import { LinearProgress, Tabs } from '../../tailwindcomponents';
import AllClothingRequests from './AllClothingRequests';
import AddNewClothingRequests from './AddNewClothingRequests';
import { EmployeeSearch } from '../../components';
import ClothingOverview from './ClothingOverview';
import { useQueryTab } from '../../utils/usePersistedTab';

function CLothingRequests() {
  const store = useSelector((state: RootState) => state);
  const isClothingRequestAdmin = store.user.me.user_clearence_groups.includes("Clothes Request");
  const { tabValue, setTabValue } = useQueryTab("tab", 0);
  const [loading, setLoading] = useState<boolean>(false);
  const [employee_id, setEmployeeId] = useState(-1);
  const tabNames = isClothingRequestAdmin ? ["All clothing requests", "Overview", "New Clothing requests"] : ["All clothing requests", "Overview"];

  return (
    <>
      <div className="w-full">
        {loading === true && <LinearProgress />}
        <div className="flex flex-wrap w-full">
          <div className="w-1/2">
            <Tabs
              tabNames={tabNames}
              onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
              tabValue={tabValue}
            />
          </div>
          <div className="w-1/2">
            {tabValue === 0 && <div className="w-1/2"> <EmployeeSearch place_holder={"Write employee name"} onSelectedEmployee={(employee_id: number) => setEmployeeId(employee_id || -1)} /> </div>}
          </div>
        </div>
        {tabValue === 0 && <AllClothingRequests searched_user_id={employee_id} setLoading={(loadingStatus: boolean) => setLoading(loadingStatus)} />}
        {tabValue === 1 && <ClothingOverview isLoading={loading} setLoading={(loadingStatus: boolean) => setLoading(loadingStatus)} />}
        {tabValue === 2 && <AddNewClothingRequests setLoading={(loadingStatus: boolean) => setLoading(loadingStatus)} />}
      </div>
    </>
  );
};
export default CLothingRequests